'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Preview;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Table = require('../../Table');

var _Table2 = _interopRequireDefault(_Table);

var _Column = require('../../Column');

var _Column2 = _interopRequireDefault(_Column);

var _getFieldAssignedPreviewData = require('../helpers/getFieldAssignedPreviewData');

var _getFieldAssignedPreviewData2 = _interopRequireDefault(_getFieldAssignedPreviewData);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Preview(props) {
  var field = props.field,
      fileFields = props.fileFields,
      data = props.data,
      attributes = props.attributes;
  var mappedData = (0, _getFieldAssignedPreviewData2.default)(data, field, fileFields, attributes);

  if (fileFields.length) {
    var fieldsToAssing = fileFields.join(',');
    var fieldWord = fileFields.length > 1 ? 'fields' : 'field';
    return _react2.default.createElement('div', null, _react2.default.createElement('p', {
      className: 'rainbow-import-records-flow_step-three-assign-field-modal-preview-text'
    }, 'Assigning', _react2.default.createElement('b', {
      className: 'rainbow-import-records-flow_step-three-assign-field-modal-preview-bold-text'
    }, " \u201C" + fieldsToAssing + "\u201D"), ' ', fieldWord + ' to', _react2.default.createElement('b', {
      className: 'rainbow-import-records-flow_step-three-assign-field-modal-preview-bold-text'
    }, " \u201C" + field + "\u201D"), ' ', 'database field'), _react2.default.createElement(_Table2.default, {
      className: 'rainbow-import-records-flow_table',
      keyField: 'id',
      data: mappedData
    }, _react2.default.createElement(_Column2.default, {
      header: field,
      field: field
    })));
  }

  return null;
}

Preview.propTypes = {
  field: _propTypes2.default.string,
  fileFields: _propTypes2.default.array,
  data: _propTypes2.default.array,
  attributes: _propTypes2.default.object.isRequired
};
Preview.defaultProps = {
  field: '',
  fileFields: [],
  data: []
};